import { cn } from '@helpers/cn';
import { TProps } from './types/TProps';

export const Pager = ({ pagesCount, currentPage, onChange, className = 'pager' }: TProps) => {
  let pages = [];
  for (let i = 1; i <= pagesCount; i++) {
    pages.push(i);
  }
  if (!currentPage) {
    currentPage = 1;
  }

  let minPage = currentPage - 2;
  let maxPage = currentPage + 2;
  if (currentPage < 5) {
    maxPage = 5;
  }
  if (currentPage === 4) {
    maxPage = 6;
  }
  if (currentPage > pagesCount - 4) {
    minPage = pagesCount - 4;
  }
  if (currentPage === pagesCount - 3) {
    minPage = pagesCount - 5;
  }

  const showPrevButton = currentPage > 1;
  const showNextButton = currentPage < pagesCount;

  const showSecondPage = minPage === 3;
  const showPreLastPage = pagesCount - maxPage === 2;

  const showFirstPage = currentPage > 3 && pagesCount > 5;
  const showLastPage = currentPage < pagesCount - 2 && pagesCount > 5;

  const showPrevDots = pagesCount > 6 && currentPage > 5 && !showSecondPage;
  const showNextDots = pagesCount > 6 && currentPage < pagesCount - 4 && !showPreLastPage;

  if (pages.indexOf(maxPage) > -1) {
    pages = pages.slice(0, pages.indexOf(maxPage) + 1);
  }
  if (pages.indexOf(minPage) > -1) {
    pages = pages.slice(pages.indexOf(minPage));
  }

  return pagesCount ? (
    <div className={cn('pager', className)}>
      {showPrevButton ? (
        <button
          type="button"
          className="page-number"
          aria-label="Previous page"
          onClick={() => onChange(currentPage - 1)}
        >
          &laquo;
        </button>
      ) : null}

      {showFirstPage ? (
        <button type="button" className="page-number" onClick={() => onChange(1)}>
          1
        </button>
      ) : null}

      {showSecondPage ? (
        <button type="button" className="page-number" onClick={() => onChange(2)}>
          2
        </button>
      ) : null}

      {showPrevDots ? <span className="page-number page-dots">...</span> : null}

      {pages.map((p, i) => {
        return (
          <button
            type="button"
            aria-label={`Page ${p}`}
            aria-current={+currentPage === p ? 'page' : undefined}
            className={+currentPage === p ? 'page-number current' : 'page-number'}
            key={i}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        );
      })}

      {showNextDots ? <span className="page-number page-dots">...</span> : null}

      {showPreLastPage ? (
        <button type="button" className="page-number" onClick={() => onChange(pagesCount - 1)}>
          {pagesCount - 1}
        </button>
      ) : null}

      {showLastPage ? (
        <button type="button" className="page-number" onClick={() => onChange(pagesCount)}>
          {pagesCount}
        </button>
      ) : null}

      {showNextButton ? (
        <button type="button" className="page-number" aria-label="Next page" onClick={() => onChange(currentPage + 1)}>
          &raquo;
        </button>
      ) : null}
    </div>
  ) : null;
};
